import React from "react";
import { Clock3, Mail, MapPin } from "lucide-react";
import { PublicPageShell } from "./PageShells";

const details = [
  { icon: Mail, title: "Email Support", content: <>Reach us anytime at <a href="mailto:team@jobzam.co" className="font-semibold text-blue-700 underline underline-offset-4">team@jobzam.co</a></> },
  { icon: Clock3, title: "Response Time", content: <>We aim to reply within <strong>24–48 hours</strong> (Mon–Fri).</> },
  { icon: MapPin, title: "Our Address", content: <>130 Shoreditch High Street<br />London, United Kingdom</> },
];

const Contact = () => (
  <PublicPageShell
    eyebrow="Support"
    title="Contact JobZam®"
    intro="Have a question, need help, or want to share feedback? We're here for you — and we usually reply within 24–48 hours."
    width="max-w-4xl"
  >
    <section className="grid gap-4 md:grid-cols-3">
      {details.map(({ icon: Icon, title, content }) => (
        <article key={title} className="rounded-3xl border border-slate-200 bg-white p-6 shadow-[0_12px_40px_rgba(15,23,42,0.06)]">
          <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-blue-50 text-blue-700">
            <Icon className="h-5 w-5" aria-hidden="true" />
          </div>
          <h2 className="mt-5 text-lg font-bold text-slate-950">{title}</h2>
          <p className="mt-2 break-words text-sm leading-6 text-slate-600">{content}</p>
        </article>
      ))}
    </section>
    <p className="mt-8 text-center text-sm text-slate-500">Thank you for helping us improve JobZam® — your feedback truly matters.</p>
  </PublicPageShell>
);

export default Contact;
